'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record } from 'immutable';
var defaults = {
  fieldType: null,
  type: null,
  options: [],
  isCustom: true,
  name: '',
  label: '',
  isRequired: true,
  numberDisplayHint: null
};

var FormField = /*#__PURE__*/function (_Record) {
  _inherits(FormField, _Record);

  function FormField() {
    _classCallCheck(this, FormField);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormField).apply(this, arguments));
  }

  _createClass(FormField, null, [{
    key: "from",
    value: function from(json) {
      return new FormField(json);
    }
  }, {
    key: "add",
    value: function add(isCustom, name, label, numberDisplayHint) {
      return new FormField({
        isCustom: isCustom,
        name: name,
        label: label,
        numberDisplayHint: numberDisplayHint
      });
    }
  }]);

  return FormField;
}(Record(defaults));

export { FormField as default };